export const GO_BANNER = 'goBanner';
export const ABOUT_BUTTON = 'aboutButton';

// GA に送信するイベント名
export const DATA_GTM_EVENT_NAME = 'data-gtm-event-name';

//　TODO MVは全部MVという定数に変更したい
export const HOT_SPRING_2022_MV = 'hotSpring2022Mv';
export const ANY_AGE_2022_MV = 'anyAge2022Mv';
export const LANGUAGE_2025_MV = 'language2025Mv';
export const NINKI_2025_MV = 'ninki2025Mv';
export const PRIMARY_2025_MV = 'primary2025Mv';
export const HOWTO_MV = 'howtoMv';
export const NEW_YEAR_2026_MV = 'newYear2026Mv';
export const YAKAI_2026_MV = 'yakai2026Mv';
export const HIRUOBI_2026_MV = 'hiruobi2026Mv';
export const PARTICIPATION_REQUEST_MV = 'participationReqMv';
export const WINTER_2026_MV = 'winter2026Mv';

export const HEADER_SEARCH_DRAWER_BUTTON = 'headerSearchDrawerButton';
export const HEADER_SEARCH_SUBMIT_BUTTON = 'headerSearchSubmitButton';

export const NEW_PLANS_MORE_LINK = 'newPlansMoreLink';
export const HOTEL_PLANS_MORE_LINK = 'hotelPlansMoreLink';
export const FARMER_PLANS_MORE_LINK = 'farmerPlansMoreLink';
export const OTHER_CATEGORY_PLANS_MORE_LINK = 'otherCategoryPlansMoreLink';
